import React, { createContext, useState } from "react";

export const SearchUserContext = createContext({});

export const initialSearchValues = {
    yearOfBudgets: [],
    companyType: "", //id from dropdown
    nationalityList: "", //id ของสัญชาติ ใน dropdown
    industryType: [], //id from dropdown
    countryList: [],
    statusList: [],
    companyName: "",
    contactName: "",
    contactDateFrom: "",
    contactDateTo: "",
    areaSizeByRaiMin: "",
    areaSizeByRaiMax: "",
    areaSizeByNganMin: "",
    areaSizeByNganMax: "",
    areaSizeByWaMin: "",
    areaSizeByWaMax: "",
    areaSizeByMetersMin: "",
    areaSizeByMetersMax: "",
    waterConsumptionMin: "",
    waterConsumptionMax: "",
    wasteWaterMin: "",
    wasteWaterMax: "",
    kwMin: "",
    kwMax: "",
    areaType: "", //id from dropdown
    isInvestmentAdvice: null,
    isVisitAreaLandInfo: null,
    channels: "", //id from d
    futureCustomerId: "",
};

export const initialPageValues = {
    page: 0,
    pageSize: 10,
    total: 0,
    totalPage: 0,
    sortBy: "yearOfBudget",
    sortDirection: "ASC",
};

const SearchCustomerFutureProvider = ({ children }) => {
    const [searchValues, setSearchValues] = useState(initialSearchValues);
    const [pageValues, setPageValues] = useState(initialPageValues);
    const [search, setSearch] = useState(true);

    return (
        <SearchUserContext.Provider
            value={{
                searchValues,
                setSearchValues,
                pageValues,
                setPageValues,
                search,
                setSearch,
            }}
        >
            {children}
        </SearchUserContext.Provider>
    );
};

export default SearchCustomerFutureProvider;
